import React from 'react';
import Icon from '../../../components/AppIcon';

const PartnerShowcase = () => {
  const partners = [
    {
      name: "Microsoft",
      icon: "Box",
      description: "Azure Cloud Solutions",
      caseStudies: 45
    },
    {
      name: "Zoho",
      icon: "Layers",
      description: "Business Suite Integration",
      caseStudies: 38
    },
    {
      name: "Acronis",
      icon: "Shield",
      description: "Backup & Security",
      caseStudies: 32
    }
  ];

  return (
    <div className="bg-muted rounded-xl p-6 md:p-8 lg:p-10 mb-8 md:mb-12 lg:mb-16">
      <div className="text-center mb-6 md:mb-8 lg:mb-10">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground mb-2 md:mb-3 font-heading">
          Technology Partner Success Stories
        </h2>
        <p className="text-sm md:text-base text-text-secondary">
          Collaborative achievements with industry-leading platforms
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {partners?.map((partner, index) => (
          <div
            key={index}
            className="bg-card rounded-xl p-4 md:p-6 text-center hover:shadow-lg transition-all duration-300 group"
          >
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center mx-auto mb-3 md:mb-4 group-hover:scale-110 transition-transform duration-300">
              <Icon name={partner?.icon} size={32} color="#ffffff" />
            </div>
            <h3 className="text-lg md:text-xl font-bold text-foreground mb-2">
              {partner?.name}
            </h3>
            <p className="text-xs md:text-sm text-text-secondary mb-3 md:mb-4">
              {partner?.description}
            </p>
            <div className="text-2xl md:text-3xl font-bold text-primary mb-1">
              {partner?.caseStudies}
            </div>
            <div className="text-xs md:text-sm text-text-secondary">
              Case Studies Available
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerShowcase;